﻿import {useMateApi} from "./useMateApi";

export const usePosInstallerApi = () => {

    const {endpoint, baseUrl} = useMateApi("ANONYMOUS");
       
    const classicPosUrl = (tenant: string) =>
        `/install/pos-cl/${tenant}`.toLowerCase();

    const fullClassicPosUrl = (tenant: string) =>
        baseUrl + classicPosUrl(tenant).substring(1);

    const windowsPosUxUrl = (tenant: string) =>
        `/install/pos-ux/${tenant}`.toLowerCase();

    const fullWindowsPosUxUrl = (tenant: string) =>
        baseUrl + windowsPosUxUrl(tenant).substring(1);

    const iOsPosUxLicenseUrl = (tenant: string) =>
        `/install/pos-ux/${tenant}/ios`.toLowerCase();
    
    const fullIosPosUxLicenseUrl = (tenant: string) =>
        baseUrl + iOsPosUxLicenseUrl(tenant).substring(1);

    const androidPosUxLicenseUrl = (tenant: string) =>
        `/install/pos-ux/${tenant}/android`.toLowerCase();
    
    const fullAndroidPosUxLicenseUrl = (tenant: string) =>
        baseUrl + androidPosUxLicenseUrl(tenant).substring(1);

    const windowsPanUxUrl = (tenant: string) =>
        `/install/pan-ux/${tenant}`.toLowerCase();

    const fullWindowsPanUxUrl = (tenant: string) =>
        baseUrl + windowsPanUxUrl(tenant).substring(1);

    const iOsPanUxLicenseUrl = (tenant: string) =>
        `/install/pan-ux/${tenant}/ios`.toLowerCase();

    const fullIosPanUxLicenseUrl = (tenant: string) =>
        baseUrl + iOsPanUxLicenseUrl(tenant).substring(1);

    const androidPanUxLicenseUrl = (tenant: string) =>
        `/install/pan-ux/${tenant}/android`.toLowerCase();

    const fullAndroidPanUxLicenseUrl = (tenant: string) =>
        baseUrl + androidPanUxLicenseUrl(tenant).substring(1);
    
    const fullAndroidInstallerUrl = (dataType: string) => {
        let app = dataType === 'pos-terminal' ? 'pos' : 'pan';
        console.log(baseUrl);
        return baseUrl + 'api/install/android/com.taptill.'+app+'.apk';        
    }
    
    const prerequisitesClassicUrl = (tenant: string) =>
        'https://storage.taptill.com/public/prerequisites/ePOS-Classic-Prerequisites.exe';
   
    const basePosLicenseLinkUrl = () =>
        'eposlicense://'+baseUrl.substring(baseUrl.indexOf('//')+2).replace('/','');

    const basePanLicenseLinkUrl = () =>
        'epanlicense://'+baseUrl.substring(baseUrl.indexOf('//')+2).replace('/','');

    return {
        fullClassicPosUrl,
        fullWindowsPosUxUrl,
        fullAndroidPosUxLicenseUrl,
        fullIosPosUxLicenseUrl,
        fullAndroidInstallerUrl,

        fullWindowsPanUxUrl,
        fullAndroidPanUxLicenseUrl,
        fullIosPanUxLicenseUrl,        
        
        basePosLicenseLinkUrl,
        basePanLicenseLinkUrl,
        prerequisitesClassicUrl
    }
}
